// import

import type {PersonNode} from 'libs/model';
import {At} from 'modules/Icon';

import {Header} from './Header';

// types

type Props = {
  author: PersonNode;
};

// component

export function BlogAuthorHeader(props: Props) {
  const {author} = props;

  return (
    <Header
      color="orange-60"
      icon={<At />}
      image={author.meta.photoImage}
      title={author.meta.title}
      type="Author"
    >
      {author.body}
    </Header>
  );
}

